import { graphql } from '@repo/common/queries/schemas/server_user_query'

export const query_get_helpscout = graphql(`
  query get_helpscout {
    me {
      helpscout_signature
    }
  }
`)
